import { Injectable } from '@angular/core';
//import { Router, CanActivate } from '@angular/router';
import { GlobalProvider } from 'src/services/global';
import { BaseHelper } from '../baseHelper';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

// @Injectable({
//   providedIn: 'root',
// })
// export class AuthGuardService implements CanActivate {
//   constructor(private router: Router, private g: GlobalProvider, private b: BaseHelper) {}

//   async canActivate(): Promise<boolean> {
//     if (this.g.loadingJwt) {
//       const delay = (ms:any) => new Promise((_) => setTimeout(_, ms));
//       const wat = await delay(500).then(() => {
//         this.g.loadingJwt = false;
//         if (this.g.profile) {
//           // console.log(`says true`);
//           return true;
//         } else {
//           this.b.navigateRoot('/login');
//           // console.log(`says false`);
//           return false;
//         }
//       });
//       // console.log(`what?`, wat);
//       return wat;
//     } else {
//       if (this.g.profile) {
//         return true;
//       } else {
//         this.b.clearJws();
//         this.b.navigateRoot('/login');
//         return false;
//       }
//     }
//   }
// }
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private g: GlobalProvider,
    private b: BaseHelper
  ) {}

  // async canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot
  // ): Promise<boolean> {
    
  //   if (this.g.loadingJwt) {
  //     await new Promise((resolve) => setTimeout(resolve, 300));
  //     this.g.loadingJwt = false;
  //   }

    
  //   if (!this.g.profile) {
  //     this.b.navigateRoot('/login');
  //     return false;
  //   }

  //   const ns = route.data?.['ns'];

    
  //   if (!ns) {
  //     return true;
  //   }

    
  //   let key: 'list' | 'create' | 'edit' = 'list';

  //   const id = route.paramMap.get('id');

  //   if (id !== null) {
  //     key = id === '0' ? 'create' : 'edit';
  //   }

    
  //   const allowed = this.g.checkAccess(ns, key);

  //   if (!allowed) {
  //     this.b.navigateRoot('/dashboard');
      
  //     return false;
  //   }

  //   return true;
  // }

  async canActivate(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> {

  if (this.g.loadingJwt) {
    await new Promise(resolve => setTimeout(resolve, 300));
    this.g.loadingJwt = false;
  }

  if (!this.g.profile) {
    this.b.navigateRoot('/login');
    return false;
  }

  const ns = route.data?.['ns'];

  if (!ns) return true;

  const id = route.paramMap.get('id');

  // DETAIL PAGE (create/edit)
  if (id !== null) {
    const key = id === '0' ? 'create' : 'edit';

    if (!this.g.checkAccess(ns, key)) {
      this.b.navigateRoot('/dashboard');
      return false;
    }
    return true;
  }

  // LISTING PAGE (allow if ANY permission)
  const hasAnyAccess =
    this.g.checkAccess(ns, 'list') ||
    this.g.checkAccess(ns, 'create') ||
    this.g.checkAccess(ns, 'edit')||
    this.g.checkAccess(ns, 'topup');

  if (!hasAnyAccess) {
    this.b.navigateRoot('/dashboard');
    return false;
  }

  return true;
}

}
